module.exports = __webpack_public_path__ + "20cc0e275f9157736c18ed81767b4911.png";